require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[13],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(194);


/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _ComboBox = _interopRequireDefault(__webpack_require__(195));

exports["default"] = _ComboBox["default"];
exports.ComboBox = _ComboBox["default"];

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _baUiCarbon = __webpack_require__(12);

var _utils = __webpack_require__(4);

var _reactDom = __webpack_require__(14);

var _downshift = _interopRequireDefault(__webpack_require__(196));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var BaPropTypes = _utils.propsUtils.BaPropTypes; // determines if using the toolkit settings to allow input that does not match an item

var allowNonItemNumberValue = function allowNonItemNumberValue(props) {
  return props.type === 'numeric';
};

var allowNonItemTextValue = function allowNonItemTextValue(props) {
  return props.type === 'text';
};

var allowNonItemValue = function allowNonItemValue(props) {
  return allowNonItemNumberValue(props) || allowNonItemTextValue(props);
};

var getLabel = function getLabel(props, item) {
  var _item$label;

  if (props.itemtoString) {
    return props.itemtoString(item);
  }

  if (typeof item === 'string') {
    return item;
  }

  return (_item$label = item == null ? void 0 : item.label) != null ? _item$label : '';
}; // return an items array based on props


var getItemsUsingProps = function getItemsUsingProps(props, selectedItem) {
  var _ref;

  var items = props.items,
      startingValues = props.startingValues;
  var list = (_ref = items != null ? items : startingValues) != null ? _ref : [];
  var listWithRef = allowNonItemValue(props) ? [{
    label: getLabel(props, selectedItem) || null
  }].concat(list) : list;
  var listWithIds = listWithRef.map(function (item) {
    return (0, _extends2["default"])({
      id: getLabel(props, item)
    }, item);
  });
  return listWithIds;
}; // return an items array based on state


var getItemsUsingState = function getItemsUsingState(props, state, selectedItem) {
  var updatedItems = state.mappedItems;

  if (allowNonItemValue(props)) {
    updatedItems[0].label = getLabel(props, selectedItem) || null;
  }

  return updatedItems;
}; // finds and returns the selectedItem in the items list
// if not found return null


var getSelectedItem = function getSelectedItem(props, items, selectedItem) {
  var labelToFind = getLabel(props, selectedItem).toLowerCase();

  if (!labelToFind) {
    return null;
  }

  var startingIndex = allowNonItemValue(props) ? 1 : 0;
  var foundItem = items.find(function (item, index) {
    return index >= startingIndex && getLabel(props, item).toLowerCase() === labelToFind;
  });

  if (foundItem) {
    return foundItem;
  }

  if (allowNonItemValue(props) && getLabel(props, items[0]).toLowerCase() === labelToFind) {
    return items[0];
  }

  return null;
};

var ComboBox = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(ComboBox, _Component);

  function ComboBox(props) {
    var _ref3;

    var _this;

    _this = _Component.call(this, props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isCarbonated", _this.props.type && !allowNonItemValue(_this.props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "mappedShouldFilterItem", function (shouldFilterItemObj) {
      var _getLabel$toLowerCase, _getLabel;

      var _this$props = _this.props,
          disableFilter = _this$props.disableFilter,
          shouldFilterItem = _this$props.shouldFilterItem;
      var inputValue = shouldFilterItemObj.inputValue,
          item = shouldFilterItemObj.item;

      if (allowNonItemValue(_this.props) && item === _this.state.mappedItems[0]) {
        // always hide the type in reference item
        return false;
      }

      if (disableFilter) {
        // toolkit supplied prop to not filter
        return true;
      }

      if (shouldFilterItem) {
        // Carbon supplied prop for client supplied filter condition
        return shouldFilterItem(shouldFilterItemObj);
      } // default: toolkit filters case insensitive and starts with


      return (_getLabel$toLowerCase = (_getLabel = getLabel(_this.props, item)) == null ? void 0 : _getLabel.toLowerCase().startsWith(inputValue == null ? void 0 : inputValue.toLowerCase())) != null ? _getLabel$toLowerCase : true;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "mappedOnChange", function (onChangeObject) {
      // toolkit changed the payload for onChange to be a selectedItem object
      // map the onChange payload to be the Carbon payload or the old toolkit payload
      _this.props.onChange == null ? void 0 : _this.props.onChange(_this.isCarbonated ? onChangeObject : onChangeObject.selectedItem || {});
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "mappedOnInputChange", function (onInputChangeObject) {
      // if carbon onInputChange pass back anything
      _this.props.onInputChange == null ? void 0 : _this.props.onInputChange(onInputChangeObject);
      _this.props.onTextChange == null ? void 0 : _this.props.onTextChange(onInputChangeObject);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkInput", function () {
      // non-item numeric entries are allowed
      // and the selectedItem is a type in value
      if (allowNonItemNumberValue(_this.props) && _this.state.mappedSelectedItem === _this.state.mappedItems[0]) {
        // the scale check is not needed: only format has
        // type=numeric and all format numerics are integers.
        var _this$props2 = _this.props,
            min = _this$props2.min,
            max = _this$props2.max;
        var label = _this.state.mappedItems[0].label;
        var valueInt = parseInt(label);
        var valueNumber = Number(label);

        if (valueInt == valueNumber && (min === undefined || valueInt > Number(min)) && (max === undefined || valueInt < Number(max))) {
          // either, no change required or need to clean value
          return String(valueInt) === label ? undefined : String(valueInt);
        } // need to clear


        return null;
      } // no change required


      return undefined;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleStateReducer", function (state, changes) {
      // this is the only state change I could find to handle mouse click
      // Carbon overloads blurInput, keyDownEnter, and onOuterClick
      if (changes.type === _downshift["default"].stateChangeTypes.mouseUp) {
        var checkedInput = _this.checkInput();

        if (checkedInput !== undefined) {
          // change required; either clear or clean the data
          return (0, _extends2["default"])({}, changes, {
            inputValue: checkedInput
          });
        }
      } // no change required


      return changes;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleKeyUp", function (_ref2) {
      var keyCode = _ref2.keyCode;

      // check if the key pressed was ENTER
      if (keyCode === 13) {
        var checkedInput = _this.checkInput();

        if (checkedInput !== undefined) {
          // change required; either clear or clean the data
          _this.mappedOnInputChange(checkedInput);
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleRef", function (node) {
      if (node) {
        var customWidth = _this.props.customWidth;
        var domNode = (0, _reactDom.findDOMNode)(node); // set the width of the ComboBox node

        domNode.style.setProperty('width', customWidth != null ? customWidth : '100%');

        if (allowNonItemValue(_this.props)) {
          // find the input tag in the ComboBox node
          var inputTag = domNode.querySelector('input');
          inputTag.addEventListener == null ? void 0 : inputTag.addEventListener('keyup', _this.handleKeyUp);
        }
      }
    });
    var selectedItem = props.selectedItem,
        selectedValue = props.selectedValue,
        initialSelectedItem = props.initialSelectedItem;

    var _item = (_ref3 = selectedItem != null ? selectedItem : selectedValue) != null ? _ref3 : initialSelectedItem;

    var mappedItems = getItemsUsingProps(props, _item);
    var mappedSelectedItem = getSelectedItem(props, mappedItems, _item);
    _this.state = {
      mappedItems: mappedItems,
      mappedSelectedItem: mappedSelectedItem
    };
    return _this;
  }

  ComboBox.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var _state$mappedItems$;

    var selectedItem = props.selectedItem,
        selectedValue = props.selectedValue,
        initialSelectedItem = props.initialSelectedItem;
    var refLabel = (_state$mappedItems$ = state.mappedItems[0]) == null ? void 0 : _state$mappedItems$.label;
    var propMappedItems = getItemsUsingProps(props, refLabel);
    var stateMappedItems = getItemsUsingState(props, state, refLabel);

    if (JSON.stringify(propMappedItems) !== JSON.stringify(stateMappedItems)) {
      return {
        mappedItems: propMappedItems,
        mappedSelectedItem: getSelectedItem(props, propMappedItems, state.mappedSelectedItem)
      };
    }

    return null;
  };

  var _proto = ComboBox.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props3 = this.props,
        currSelectedItem = _this$props3.selectedItem,
        currSelectedValue = _this$props3.selectedValue;
    var prevSelectedItem = prevProps.selectedItem,
        prevSelectedValue = prevProps.selectedValue;
    var currItem = currSelectedItem != null ? currSelectedItem : currSelectedValue;
    var prevItem = prevSelectedItem != null ? prevSelectedItem : prevSelectedValue;
    var currLabel = currItem ? getLabel(this.props, currItem) : undefined;
    var prevLabel = prevItem ? getLabel(this.props, prevItem) : undefined;

    if (currLabel !== prevLabel) {
      var stateMappedItems = getItemsUsingState(this.props, this.state, currItem);
      this.setState({
        mappedItems: stateMappedItems,
        mappedSelectedItem: getSelectedItem(this.props, stateMappedItems, currItem)
      });
    }
  } // determines if ComboBox props are to behave as Carbon props (type set to a non-toolkit option)
  ;

  _proto.render = function render() {
    var _this$state$mappedSel, _this$state$mappedSel2;

    var _this$props4 = this.props,
        ariaLabel = _this$props4.ariaLabel,
        invalid = _this$props4.invalid,
        invalidText = _this$props4.invalidText,
        items = _this$props4.items,
        onChange = _this$props4.onChange,
        onInputChange = _this$props4.onInputChange,
        selectedItem = _this$props4.selectedItem,
        shouldFilterItem = _this$props4.shouldFilterItem,
        size = _this$props4.size,
        type = _this$props4.type,
        ariaLabelOfDropdown = _this$props4.ariaLabelOfDropdown,
        customWidth = _this$props4.customWidth,
        disableFilter = _this$props4.disableFilter,
        dropdownFooterRenderer = _this$props4.dropdownFooterRenderer,
        dropdownHeaderRenderer = _this$props4.dropdownHeaderRenderer,
        grouped = _this$props4.grouped,
        hasValidationError = _this$props4.hasValidationError,
        inputIconLeft = _this$props4.inputIconLeft,
        isAttachedToDomNode = _this$props4.isAttachedToDomNode,
        numberInputExtraOptions = _this$props4.numberInputExtraOptions,
        onTextChange = _this$props4.onTextChange,
        selectedValue = _this$props4.selectedValue,
        startingValues = _this$props4.startingValues,
        textInputExtraOptions = _this$props4.textInputExtraOptions,
        validationErrorText = _this$props4.validationErrorText,
        otherCarbonComboBoxProps = (0, _objectWithoutPropertiesLoose2["default"])(_this$props4, ["ariaLabel", "invalid", "invalidText", "items", "onChange", "onInputChange", "selectedItem", "shouldFilterItem", "size", "type", "ariaLabelOfDropdown", "customWidth", "disableFilter", "dropdownFooterRenderer", "dropdownHeaderRenderer", "grouped", "hasValidationError", "inputIconLeft", "isAttachedToDomNode", "numberInputExtraOptions", "onTextChange", "selectedValue", "startingValues", "textInputExtraOptions", "validationErrorText"]);
    var mappedAriaLabel = ariaLabel != null ? ariaLabel : ariaLabelOfDropdown;
    var mappedInvalid = invalid != null ? invalid : hasValidationError;
    var mappedInvalidText = invalidText != null ? invalidText : validationErrorText;
    var mappedOnChange = onChange || allowNonItemValue(this.props) ? this.mappedOnChange : undefined;
    var mappedOnInputChange = onInputChange || onTextChange || allowNonItemValue(this.props) ? this.mappedOnInputChange : undefined;
    var mappedSize = size === 'small' ? 'sm' : size === 'large' ? 'lg' : size === 'normal' ? undefined : size;
    var mappedType = allowNonItemValue(this.props) ? undefined : type;
    return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.ComboBox, (0, _extends2["default"])({
      "data-tid": 'ba-common-combobox__list-dropdown',
      ref: this.handleRef
    }, otherCarbonComboBoxProps, {
      ariaLabel: mappedAriaLabel,
      invalid: mappedInvalid,
      invalidText: mappedInvalidText,
      items: this.state.mappedItems // onChange is a utility for this controlled component to communicate to a
      // consuming component when a specific dropdown item is selected.
      ,
      onChange: mappedOnChange // Callback function to notify consumer when the text input changes.
      // This provides support to change available items based on the text.
      ,
      onInputChange: mappedOnInputChange,
      selectedItem: (_this$state$mappedSel = (_this$state$mappedSel2 = this.state.mappedSelectedItem) == null ? void 0 : _this$state$mappedSel2.label) != null ? _this$state$mappedSel : null,
      shouldFilterItem: this.mappedShouldFilterItem,
      size: mappedSize,
      type: mappedType,
      downshiftProps: {
        stateReducer: this.handleStateReducer
      }
    }));
  };

  return ComboBox;
}(_react.Component);

exports["default"] = ComboBox;
(0, _defineProperty2["default"])(ComboBox, "__ComboBox__", true);
(0, _defineProperty2["default"])(ComboBox, "propTypes", (0, _extends2["default"])({}, _baUiCarbon.ComboBox.propTypes, {
  /** Size in carbon is 'sm', 'lg', or 'xl', the toolkit 'small', 'normal', and 'large' are deprecated */
  size: _propTypes["default"].oneOf(['large', 'lg', 'normal', 'sm', 'small', 'xl']),

  /** type in carbon is 'default' or 'variant', the toolkit 'text' or 'numeric' options are deprecated */
  // ComboBox'es by default only allow values that match an item in the items list.
  // The toolkit types (numeric or text) indicates the ComboBox value does not have to match an item in the items.
  // ie: if types is (numeric or text) the user can type in a value and it does not have to match an item in the items.
  type: _propTypes["default"].oneOf(['default', 'numeric', 'text', 'variant']).isRequired,

  /** deprecated - not supported in Carbon */
  allowEmpty: BaPropTypes.deprecated(' is ignored and not applicable to carbon combobox'),

  /** deprecated - use ariaLabel */
  ariaLabelOfDropdown: BaPropTypes.deprecated('deprecated - use ariaLabel'),

  /** deprecated - not supported in Carbon */
  customWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** deprecated - use shouldFilterItem */
  disableFilter: BaPropTypes.deprecated('deprecated - use shouldFilterItem'),

  /** deprecated - not supported in Carbon */
  dropdownFooterRenderer: BaPropTypes.deprecated('deprecated - not supported in Carbon'),

  /** deprecated - not supported in Carbon */
  dropdownHeaderRenderer: BaPropTypes.deprecated('deprecated - not supported in Carbon'),

  /** deprecated - not supported in Carbon */
  grouped: BaPropTypes.deprecated('deprecated - not supported in Carbon'),

  /** deprecated - use invalid */
  hasValidationError: BaPropTypes.deprecated('deprecated - use invalid'),

  /** deprecated - not supported in Carbon */
  inputIconLeft: BaPropTypes.deprecated('deprecated - not supported in Carbon'),

  /** deprecated - not supported in Carbon */
  isAttachedToDomNode: BaPropTypes.deprecated('deprecated - not supported in Carbon'),

  /** deprecated - not supported in Carbon */
  max: BaPropTypes.deprecated(' is ignored and not applicable to carbon combobox'),

  /** deprecated - not supported in Carbon */
  min: BaPropTypes.deprecated(' is ignored and not applicable to carbon combobox'),

  /** deprecated - not supported in Carbon */
  numberInputExtraOptions: BaPropTypes.deprecated('deprecated - not supported in Carbon'),

  /** deprecated - use onInputChange */
  onTextChange: BaPropTypes.deprecated('deprecated - use onInputChange'),

  /** deprecated - not supported in Carbon */
  scale: BaPropTypes.deprecated(' is ignored and not applicable to carbon combobox'),

  /** deprecated - use selectedItem */
  selectedValue: BaPropTypes.deprecated('deprecated - use selectedItem'),

  /** deprecated - use items */
  startingValues: BaPropTypes.deprecated('deprecated - use items'),

  /** deprecated - not supported in Carbon */
  textInputExtraOptions: BaPropTypes.deprecated('deprecated - not supported in Carbon'),

  /** deprecated - use invalidText */
  validationErrorText: BaPropTypes.deprecated('deprecated - use invalidText')
}));

/***/ }),

/***/ 196:
/***/ (function(module, exports) {

module.exports = require("downshift");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ })

},[[193,0]]]);
});